<div class="row">
	<div class="col-xs-12">
		<h1>Virtual Card Setup</h1>
	</div>
</div>
<sl-error-summary [errors]="errors"></sl-error-summary>
<sl-form [model]="entity" [fields]="fields" [options]="options" [form]="form">
	<div class="row actions" *ngIf="showTestButton">
		<button mat-raised-button color="primary" type="button" (click)="testConnection()">Test Connection</button>
	</div>
	<div class="row actions" *ngIf="form.dirty">
		<button mat-raised-button type="button" (click)="cancelChanges()">Cancel</button>
		<button mat-raised-button color="primary" class="pull-right" type="button" (click)="saveChanges()" [disabled]="!form.valid">Save
			Changes</button>
	</div>
</sl-form>
